import React, { MouseEventHandler, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import Box from '@mui/material/Box'
import DialogContent from '@mui/material/DialogContent'
import { injectDataAttributes } from '@utils/dataAttributes'
import { SVGIcon } from '@components/ui-css/SVGIcon'
import { Button } from '@components/ui-css/Button'
import { useEnvironment } from '@hooks/useEnvironment'
import { StyledDialog, StyledDialogActions, StyledDialogCloseButton, StyledDialogTitle } from './Modal.style'
import { ThemeWrapper } from '../Theme/ThemeWrapper'
import styles from '../../ui-css/Modal/styles/Modal.module.scss'

export interface ModalProps {
  open: boolean
  onClose: () => void
  title?: string
  footer?: ReactNode
  children?: ReactNode
}

export const Modal: React.FC<ModalProps> = ({ open, onClose, title, footer, children }) => {
  const { brand } = useEnvironment()

  return (
    <StyledDialog open={open} onClose={onClose} {...injectDataAttributes('modal.root')}>
      <ThemeWrapper appId="directbilling-modal" brand={brand}>
        <div className={styles.container}>
          <div className={styles.header}>
            {title && <span className={styles.title}>{title}</span>}
            <SVGIcon
              className={styles.closeButton}
              library="base"
              name="close"
              onClick={onClose}
              {...injectDataAttributes('modal.close')}
            />
          </div>

          <div className={styles.content} {...injectDataAttributes('modal.content')}>
            {children && children}
          </div>

          <div className={styles.actionContainer} {...injectDataAttributes('modal.actions')}>
            {footer && footer}
            {!footer && <ModalFooter onClose={onClose} />}
          </div>
        </div>
      </ThemeWrapper>
    </StyledDialog>
  )
}

interface ModalFooterProps {
  onClose: () => void
}

const ModalFooter: React.FC<ModalFooterProps> = ({ onClose }) => {
  const { translationNamespace } = useEnvironment()
  const { t } = useTranslation(translationNamespace)

  return (
    <Box textAlign={'center'}>
      <Button onClick={onClose} aria-label="close" {...injectDataAttributes('modal.close')}>
        {t('DirectBilling.Claim.Button.db-btn-close')}
      </Button>
    </Box>
  )
}
